// extracted by mini-css-extract-plugin
export var modalFooter = "_sm-0";